import styled from "styled-components"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { CellText } from "components/EvtKit/list-items/CellText"
import { CellActionButtons } from "components/EvtKit/list-items/CellActionButtons"
import { useAppSelector } from "reducers/store"
import { memo, ReactElement, useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import WebhookIsPublishedModal from "./WebhookIsPublishedModal"
import { CellSwitch } from "components/EvtKit/list-items/CellSwitch"

interface ContainerProps {
  align?: string
  direction?: string
  justify?: string
}

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  gap: 16px;
  margin-top: 24px;
  padding-right: 24px;
`

const ListItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 16px;
  padding-right: 24px;
`

const ListItemsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.08);
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`

interface Props {
  hasData: boolean
}

const WebhookList = (props: Props): ReactElement => {
  const [showIsPublishedModal, setShowIsPublishedModal] = useState(false)

  const [selectedItem, setSelectedItem] = useState<App.IWebhook | null>(null)

  const { hasData } = props

  const navigate = useNavigate()

  const { data, loading } = useAppSelector((state) => state.webhook.webhookList)

  const handleClickEdit = useCallback((item: App.IWebhook) => {
    navigate(`/webhooks/${item._id}`)
  }, [])

  const handleCloseIsPublishedModal = useCallback(() => {
    setSelectedItem(null)
    setShowIsPublishedModal(false)
  }, [])

  const handleSwitchClick = useCallback((item: App.IWebhook) => {
    setSelectedItem(item)
    setShowIsPublishedModal(true)
  }, [])

  return (
    <Container align="flex-start">
      <Content>
        {hasData && (
          <ListItemsContainer>
            {loading && <Spinner />}
            {!loading &&
              data?.map((item, index) => (
                <ListItemsContent key={index}>
                  <CellText title="Nome" content={item.name} />
                  <CellText title="Path" content={item.path} />
                  <CellText title="Content-Type" content={item.contentType} />
                  <CellText title="Produto" content={item.product} />
                  <CellSwitch initialState={item.isPublished} onClickSwitch={() => handleSwitchClick(item)} />
                  <CellActionButtons onClickEdit={() => handleClickEdit(item)} />
                </ListItemsContent>
              ))}
          </ListItemsContainer>
        )}
        <WebhookIsPublishedModal
          webhookData={selectedItem}
          isOpen={showIsPublishedModal && !!selectedItem}
          onClose={handleCloseIsPublishedModal}
        />
      </Content>
    </Container>
  )
}

export default memo(WebhookList)
